import { getCountries, getCountryCallingCode, type CountryCode } from '@leangap/types'
import { countries } from '@/utils/countries'

export type PhoneCountryOption = {
	code: CountryCode
	callingCode: string
	label: string
}

const PINNED_COUNTRY_CODES: CountryCode[] = ['US', 'CA', 'IN']

export function sanitizeNationalNumber(value: string | undefined | null): string {
	if (value == null) return ''
	return String(value).replace(/\D/g, '')
}

export function phoneCountryDisplayName(option: PhoneCountryOption): string {
	return `${option.label} (+${option.callingCode})`
}

export function getPhoneCountryOptions(): PhoneCountryOption[] {
	const labels = new Map(countries.map((country) => [country.code, country.label]))
	const all = getCountries()
		.filter((code): code is CountryCode => labels.has(code))
		.map((code) => ({
			code,
			callingCode: getCountryCallingCode(code),
			label: labels.get(code) as string,
		}))
	const pinned = PINNED_COUNTRY_CODES.map((code) => all.find((item) => item.code === code)).filter(
		(item): item is PhoneCountryOption => Boolean(item)
	)
	const pinnedSet = new Set(PINNED_COUNTRY_CODES)
	const rest = all
		.filter((item) => !pinnedSet.has(item.code))
		.sort((a, b) => a.label.localeCompare(b.label))
	return [...pinned, ...rest]
}

export const PHONE_COUNTRY_OPTIONS = getPhoneCountryOptions()
